<template>
  <div class="card-many-to-many__list-wrapper">
    <div class="card-many-to-many__list">
      <div
        v-for="item in value"
        :key="item.id"
        class="card-many-to-many__item card-link-row"
        :class="{
          'card-link-row--unnamed': item.value === null || item.value === '',
        }"
      >
        <span class="card-many-to-many__name">
          {{ item.value || 'unnamed row ' + item.id }}
        </span>
      </div>
      <div
        v-if="shouldFetchRow"
        class="card-many-to-many__item card-link-row"
        :class="{
          'card-many-to-many__item--loading': isFetchingRow,
        }"
      >
        <div v-if="isFetchingRow" class="loading"></div>
        <span v-else>...</span>
      </div>
    </div>
  </div>
</template>

<script>
import { LINKED_ITEMS_DEFAULT_LOAD_COUNT } from '@grouper/modules/database/constants'

export default {
  height: 22,
  name: 'RowCardFieldLinkRow',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    shouldFetchRow() {
      return (
        this.value?.length === LINKED_ITEMS_DEFAULT_LOAD_COUNT &&
        !this.row._?.fullyLoaded
      )
    },
    isFetchingRow() {
      return this.row._?.fetching
    },
  },
}
</script>
